import React from 'react';

const DeleteModal = ({ productToDelete, deleteQuantity, handleDeleteQuantityChange, handleDelete, closeDeleteModal }) => {
    return (
        <div className="delete-modal">
            <div className="modal-content">
                <h3>How many would you like to delete?</h3>
                <input
                    type="number"
                    min="1"
                    max={productToDelete ? productToDelete.quantity : 1} // Limit input to available quantity
                    value={deleteQuantity}
                    onChange={handleDeleteQuantityChange} // Ensure user can't input more than available
                />
                <div className="modal-actions">
                    <button onClick={closeDeleteModal}>Cancel</button>
                    <button onClick={handleDelete}>Confirm</button>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;
